import { render, staticRenderFns } from "./OpenAiBaseForm.vue?vue&type=template&id=661e3b32&scoped=true&"
import script from "./OpenAiBaseForm.vue?vue&type=script&lang=js&"
export * from "./OpenAiBaseForm.vue?vue&type=script&lang=js&"
import style0 from "./OpenAiBaseForm.vue?vue&type=style&index=0&id=661e3b32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661e3b32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('661e3b32')) {
      api.createRecord('661e3b32', component.options)
    } else {
      api.reload('661e3b32', component.options)
    }
    module.hot.accept("./OpenAiBaseForm.vue?vue&type=template&id=661e3b32&scoped=true&", function () {
      api.rerender('661e3b32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Form/OpenAiBaseForm.vue"
export default component.exports